export default "__VITE_ASSET__jpYkATF4__"